import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import startsWith from 'lodash/startsWith';
import { persistStore } from 'redux-persist';
import { requester } from '../api/config';
import SessionStorage from '../storage';
import { getUserToken } from './modules/auth/reducer';
import appReducer from './rootReducer';
import rootSaga from './rootSaga';
import { getRef } from './modules/ui/reducer';
import { inDevelopment } from 'shared/helpers/utils';
import { Actions } from '@wahaaabello/redux-async-actions';
import { RootState } from '../types';

const middlewares = [];

const sagaMiddleware = createSagaMiddleware();

middlewares.push(thunk as ThunkMiddleware<RootState, Actions>);
middlewares.push(sagaMiddleware);

inDevelopment(() => {
  const logger = createLogger({
    collapsed: true,
    predicate: (_, action) => !startsWith(action.type, '@@redux-form')
  });
  middlewares.push(logger);
});

const userToken = SessionStorage.getItem('userToken');
const showSidebar = SessionStorage.getItem('showSidebar');
const preloadedState = {
  app: {
    auth: {
      userToken
    }
  },
  ui: {
    showSidebar: showSidebar === null ? true : showSidebar,
    ref: ''
  }
};

const enhancer = applyMiddleware(...middlewares);

const enhancerWithDevTools = composeWithDevTools(enhancer);

const store = createStore(
  appReducer,
  preloadedState,
  inDevelopment(
    () => enhancerWithDevTools,
    () => enhancer
  )
);

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

requester.interceptors.request.use(({ data = {}, ...restConfig }) => {
  const ref = getRef(store.getState());
  const nextData = {
    ...data,
    platform: 'web',
    ref
  };
  const usertoken = getUserToken(store.getState());
  if (usertoken) nextData.usertoken = usertoken;
  return {
    data: nextData,
    ...restConfig
  };
});

export default store;
